import styled from "@emotion/styled";
import { FormControl } from "@mui/material";

export const MarketingMaterialsFiltersContainer = styled.div({
	display: "flex",
	gap: "8px",
	flexWrap: "wrap",
	alignItems: "center"
});

export const SortFormControl = styled(FormControl)(({ theme }) => ({
	minWidth: 120,
	margin: theme.spacing(1),
	[theme.breakpoints.up("lg")]: {
		minWidth: 220,
		maxWidth: 250,
		marginLeft: theme.spacing(8)
	},
	"& .MuiOutlinedInput-root": {
		backgroundColor: "#fff"
	}
}));
